import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=2e07570e&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=ts&"
export * from "./Metadata.vue?vue&type=script&lang=ts&"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=2e07570e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e07570e",
  null
  
)

export default component.exports